import type { IBatchStore } from './batch-store-types';
import { PERMISSION } from '../../modules/newAuth/model/User';
import {
  RemoteBatchData,
  RemoteControlEventType,
} from '../../containers/Batch/RemoteBatchController';
import { showConfirmModal } from '../../modules/modals/confirmService';
import { storeEmitter } from './initializeEmitter';

export const remoteControlMixin = {

  sendRemoteInstruction(this: IBatchStore, remoteData: any): void {
    if (this.canSendRemoteInstruction()) {
      this.remoteBatchData = remoteData;
      this.emitBatchData();
      this.remoteBatchData = null;
    }
  },

  canSendRemoteInstruction(this: IBatchStore): boolean {
    return this.canToggleRemoteControl() && this.remoteControl;
  },

  canExecuteRemoteCode(this: IBatchStore, data: any): boolean {
    return this.canEmit && data.remoteBatchData && this.canControlPlant();
  },

  canToggleRemoteControl(this: IBatchStore): boolean {
    const { websocketStore, connectionStore, newAuthStore } = this.rootStore;
    const { user } = newAuthStore;

    return websocketStore.isTrulyConnected
      && connectionStore.isOnline
      && !this.canEmit
      && !this.replayMode
      && !!user?.hasAccess(PERMISSION.BATCH_REMOTE);
  },

  toggleRemoteControl(this: IBatchStore): void {
    if (this.remoteControl) {
      this.sendRemoteInstruction(
        RemoteBatchData(
          RemoteControlEventType.USER_INFO,
          null,
          { activeRemoteUser: false },
        ),
      );

      this.setTimeout(() => {
        this.remoteControl = false;
      }, 0);

    } else {
      this.remoteControl = !this.remoteControl;

      this.sendRemoteInstruction(
        RemoteBatchData(
          RemoteControlEventType.USER_INFO,
          null,
          { activeRemoteUser: true },
        ),
      );
    }
  },

  takeBatchControl(this: IBatchStore): void {
    showConfirmModal({
      title: 'Do you want to take over the Batch control?',
      message: 'Taking the Batch control during the load is very risky and not recommended!',
      okLabel: 'Yes',
      cancelLabel: 'No',
    }).then(() => {
      this.stopObserve = true;
      this.canEmit = true;
      storeEmitter(this.emitter);

      if (this.isDemo) {
        this.pac.init(this.pacStatus);
      }

      this.start();

      this.setTimeout(() => {
        this.stopObserve = false;
      }, 2000);

    });
  },

};
